import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const BrandEdit = () => {
  const users = {
    brand_id: "",
    brand_name: "",
    manuf_name: "",
    manuf_state: "",
    status: "",
  };

  const [BrandEditUser, setBrandEditUser] = useState(users);
  const [BrandImage, setBrandImage] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPedagogyData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_brand_by_id",
          {
            brand_id: id,
          }
        );
        setBrandEditUser(response.data?.result || users);

      } catch (error) {
        console.error("Error fetching Pedagogy data!", error);
      }
    };

    fetchPedagogyData();
  }, [id]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setBrandEditUser({ ...BrandEditUser, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("brand_id", id);
    formData.append("brand_name", BrandEditUser.brand_name);
    formData.append("manuf_name", BrandEditUser.manuf_name);
    formData.append("manuf_state", BrandEditUser.manuf_state);
    formData.append("status", BrandEditUser.status);

    if (BrandImage) formData.append("brand_logo", BrandImage);

    try {
      const response = await axios.post(
        `https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_brand`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

     if (response.data?.status === true) {
      toast.success(response.data.message || "Brand updated successfully");
      window.location.href = "/brand-list";
    } else {
      toast.error(response.data.message || "Failed to update Brand");
    }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Brand Edit</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Brand</a>
                </li>
                <li className="breadcrumb-item active">Brand Edit</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-xl-9 col-lg-8 ">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Update Thumbnail Photo</h4>
              </div>
              <div className="card-body">
                <div className="dropzone bg-light-subtle py-5">
                  <div className="fallback">
                    <input
                      name="brand_logo"
                      type="file"
                      onChange={(e) => setBrandImage(e.target.files[0])}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">General Information</h4>
              </div>
              <div className="card-body">
                <form onSubmit={submitForm}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="brand_name" className="form-label">
                          Brand Title
                        </label>
                        <input
                          type="text"
                          id="brand_name"
                          className="form-control"
                          placeholder="Enter Title"
                          name="brand_name"
                          value={BrandEditUser.brand_name}
                          onChange={changeHandler}
                          required
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 mb-3">
                      <label htmlFor="manuf_state" className="form-label text-dark">
                        Manufacturer State
                      </label>
                      <input
                        type="text"
                        id="manuf_state"
                        name='manuf_state'
                        value={BrandEditUser.manuf_state}
                        onChange={changeHandler}
                        className="form-control"
                        placeholder="Enter Manufacturer State"
                      />
                    </div>

                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="manuf_name" className="form-label">
                          Manufacturer Name
                        </label>
                        <input
                          type="text"
                          id="manuf_name"
                          className="form-control"
                          placeholder="Enter Manufacturer Name"
                          name="manuf_name"
                          value={BrandEditUser.manuf_name}
                          onChange={changeHandler}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <select
                          className="form-control"
                          id="status"
                          name="status"
                          value={BrandEditUser.status}
                          onChange={changeHandler}
                          required
                        >
                          <option value="">Select Status</option>
                          <option value="Active">Active</option>
                          <option value="InActive">InActive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 bg-light mb-3 rounded">
                    <div className="row justify-content-end g-2">
                      <div className="col-lg-2">
                        <button
                          type="submit"
                          className="btn btn-outline-secondary w-100"
                        >
                          Save Change
                        </button>
                      </div>
                      <div className="col-lg-2">
                        <Link
                          to="/brand-list"
                          className="btn btn-primary w-100"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default BrandEdit;
